import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { filesDiffID, headerHeight, issuesID, vulnerabilitiesID, } from "../constants";
import { sourceFiltered as fileDiffSourceFiltered } from "./filesDiffSlice";
import { focusTamperingIssue } from "./issuesDiffSlice";
import { filterByLink } from "./issuesSlice";
import { restoreState } from "./utils";
import { cveFiltered, sourceFiltered as vulnerabilitySourceFiltered, } from "./vulnerabilitySlice";
export const initialState = {
    isDeleted: false,
    scrollTo: null,
};
export const sdlcReportSlice = createSlice({
    name: "sdlcReport",
    initialState: initialState,
    reducers: {
        reportCleared: () => {
            return cloneDeep(initialState);
        },
        initializeState: (state, action) => {
            return restoreState(state, action.payload, "sdlcReport");
        },
        scrollTo: (state, action) => {
            state.scrollTo = action.payload;
        },
        reportDeleted: (state) => {
            state.isDeleted = true;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(filterByLink, (state) => {
            state.scrollTo = {
                id: issuesID,
                offset: headerHeight,
            };
        });
        builder.addCase(cveFiltered, (state) => {
            state.scrollTo = {
                id: vulnerabilitiesID,
                offset: headerHeight,
            };
        });
        builder.addCase(vulnerabilitySourceFiltered, (state) => {
            state.scrollTo = {
                id: vulnerabilitiesID,
                offset: headerHeight,
            };
        });
        builder.addCase(focusTamperingIssue, (state, action) => {
            state.scrollTo = {
                id: action.payload,
                offset: 60,
            };
        });
        builder.addCase(fileDiffSourceFiltered, (state) => {
            state.scrollTo = {
                id: filesDiffID,
                offset: 0,
            };
        });
    },
});
export const { initializeState, reportCleared, scrollTo, reportDeleted } = sdlcReportSlice.actions;
export const selectScrollTo = (state) => state.report.sdlcReport.scrollTo;
export const selectIsReportDeleted = (state) => state.report.sdlcReport.isDeleted;
export const reportReducer = sdlcReportSlice.reducer;
export * as default from "./sdlcReportSlice";
//# sourceMappingURL=sdlcReportSlice.js.map